import { useState } from 'react';
/**
 * Hook to use the hover state of a flyout
 * @param {string} flyoutId The id of the flyout, must also be passed to the flyout itself
 * @returns {UseHoverState}
 */
export var useHoverState = function (flyoutId, anchorId, anchorOffsets) {
    var _a = useState(false), open = _a[0], setOpen = _a[1];
    var openFlyout = function () { return setOpen(true); };
    var closeFlyout = function () { return setOpen(false); };
    var flyout = document.getElementById(flyoutId);
    var anchor = document.getElementById(anchorId);
    if (flyout) {
        flyout.addEventListener('mouseleave', function (e) {
            var flyoutDimensions = flyout.getBoundingClientRect();
            if (e.clientX < flyoutDimensions.left ||
                e.clientX > flyoutDimensions.right ||
                e.clientY < flyoutDimensions.top ||
                e.clientY > flyoutDimensions.bottom) {
                closeFlyout();
            }
        });
    }
    if (anchor) {
        anchor.addEventListener('mouseleave', function (e) {
            var _a, _b, _c, _d;
            var anchorDimensions = anchor.getBoundingClientRect();
            if (e.clientX < anchorDimensions.left + ((_a = anchorOffsets === null || anchorOffsets === void 0 ? void 0 : anchorOffsets.left) !== null && _a !== void 0 ? _a : 0) ||
                e.clientX > anchorDimensions.right + ((_b = anchorOffsets === null || anchorOffsets === void 0 ? void 0 : anchorOffsets.right) !== null && _b !== void 0 ? _b : 0) ||
                e.clientY < anchorDimensions.top + ((_c = anchorOffsets === null || anchorOffsets === void 0 ? void 0 : anchorOffsets.top) !== null && _c !== void 0 ? _c : 0) ||
                e.clientY > anchorDimensions.bottom + ((_d = anchorOffsets === null || anchorOffsets === void 0 ? void 0 : anchorOffsets.bottom) !== null && _d !== void 0 ? _d : 0)) {
                closeFlyout();
            }
        });
    }
    return { open: open, closeFlyout: closeFlyout, openFlyout: openFlyout };
};
